/**
 * Console gate: when REACT_APP_DEBUG is not "true", no-op console.log, console.warn, and console.debug
 * so built apps don't print those logs. console.error is left unchanged (errors still show and can go to HyperDX).
 * Toggle logs by setting REACT_APP_DEBUG=true in the relevant .env file.
 */
const debugOn =
  typeof process !== 'undefined' &&
  process.env?.REACT_APP_DEBUG === 'true';

if (!debugOn) {
  const noop = () => {};
  if (typeof console !== 'undefined') {
    console.log = noop;
    console.warn = noop;
    console.debug = noop;
  }
}
